import { render, staticRenderFns } from "./Roomconfig.vue?vue&type=template&id=50aa6b50&scoped=true"
import script from "./Roomconfig.vue?vue&type=script&lang=js"
export * from "./Roomconfig.vue?vue&type=script&lang=js"
import style0 from "./Roomconfig.vue?vue&type=style&index=0&id=50aa6b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa6b50",
  null
  
)

export default component.exports